import IntegrationStatusTag from "./IntegrationStatusTag"

interface Props {
  integrationId: string
  className?: string
  statusClassName?: string
}

const IntegrationViewsStatusTag = ({
  integrationId,
  className = "",
  statusClassName
}: Props) => (
  <div className={`inline-flex items-center gap-2 ${className}`}>
    <IntegrationStatusTag
      integrationId={integrationId}
      className={statusClassName}
    />
  </div>
)

export default IntegrationViewsStatusTag
